import {initMainHeader} from '../js/src/header-init';
import '../scss/pages/terms.scss';

initMainHeader();
